import { render, staticRenderFns } from "./HeaderV2UserTitleAtom.vue?vue&type=template&id=60860ea6&scoped=true&"
import script from "./HeaderV2UserTitleAtom.vue?vue&type=script&lang=ts&"
export * from "./HeaderV2UserTitleAtom.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderV2UserTitleAtom.vue?vue&type=style&index=0&id=60860ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60860ea6",
  null
  
)

export default component.exports